module.exports = __webpack_public_path__ + "static/img/bg-fr.aff8ef70.png";